import { useState } from 'react';
import { Card, Tabs, Button, Badge, Modal, Input } from '@getpay93/ui';
import type { ProofStatus } from '@getpay93/api';
import { useProofs, useReviewProof } from '../../data/hooks';
import { money, shortDate } from '../../lib/format';
import { ProofImage } from './ProofImage';

export function Comprobantes() {
  const [tab, setTab] = useState<ProofStatus>('pending_review');
  const proofs = useProofs(tab);
  const review = useReviewProof();
  const [rejectId, setRejectId] = useState('');
  const [rejectNote, setRejectNote] = useState('');
  const [zoomId, setZoomId] = useState('');

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      <Tabs
        tabs={[{ id: 'pending_review', label: 'Por revisar' }, { id: 'approved', label: 'Aprobados' }, { id: 'rejected', label: 'Rechazados' }]}
        value={tab}
        onChange={(id) => setTab(id as ProofStatus)}
      />
      {proofs.isLoading ? <p style={{ color: 'var(--text-hint)' }}>Cargando…</p> : null}
      {proofs.data && proofs.data.length === 0 ? <Card><p style={{ margin: 0, color: 'var(--text-hint)' }}>Sin comprobantes.</p></Card> : null}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 14 }}>
        {(proofs.data ?? []).map((p) => (
          <Card key={p.id} padding={0} style={{ overflow: 'hidden' }}>
            <button onClick={() => setZoomId(p.id)} style={{ display: 'block', width: '100%', border: 'none', padding: 0, cursor: 'zoom-in', background: 'transparent' }}>
              <ProofImage proofId={p.id} style={{ width: '100%', height: 160 }} />
            </button>
            <div style={{ padding: 14 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <strong style={{ color: 'var(--text-strong)' }}>{p.clientName}</strong>
                <span style={{ fontWeight: 800, color: 'var(--brand-green)' }}>{money(p.amount)}</span>
              </div>
              <div style={{ fontSize: 13, color: 'var(--text-hint)' }}>Pagó {shortDate(p.paidAt)}{p.paymentMethod ? ` · ${p.paymentMethod}` : ''}</div>
              {p.status === 'pending_review' ? (
                <div style={{ display: 'flex', gap: 8, marginTop: 12 }}>
                  <Button size="sm" fullWidth onClick={() => review.mutate({ id: p.id, body: { decision: 'approved' } })}>Aprobar</Button>
                  <Button size="sm" variant="danger" onClick={() => { setRejectId(p.id); setRejectNote(''); }}>Rechazar</Button>
                </div>
              ) : (
                <div style={{ marginTop: 10 }}><Badge tone={p.status === 'approved' ? 'paid' : 'overdue'}>{p.status}</Badge>{p.reviewNote ? <div style={{ fontSize: 12, color: 'var(--text-hint)', marginTop: 6 }}>{p.reviewNote}</div> : null}</div>
              )}
            </div>
          </Card>
        ))}
      </div>

      {rejectId ? (
        <Modal open onClose={() => setRejectId('')} title="Rechazar comprobante" subtitle="Explica el motivo al cliente" footer={<><Button variant="ghost" onClick={() => setRejectId('')}>Cancelar</Button><Button variant="danger" onClick={() => review.mutate({ id: rejectId, body: { decision: 'rejected', note: rejectNote || undefined } }, { onSuccess: () => setRejectId('') })}>Rechazar</Button></>}>
          <Input label="Motivo" value={rejectNote} onChange={(e) => setRejectNote(e.currentTarget.value)} />
        </Modal>
      ) : null}

      {zoomId ? (
        <Modal open onClose={() => setZoomId('')} title="Comprobante" width={520}>
          <ProofImage proofId={zoomId} style={{ width: '100%', maxHeight: '70vh' }} />
        </Modal>
      ) : null}
    </div>
  );
}
